import styled from '@emotion/styled';

export const SadaCommentsSection = styled.div`
  .ant-empty {
    margin: 0;
  }
`;
